<template>
    <j-abm name="zone"
        avatar="zone"
        :suppliers="suppliers"
        :features="{
            search: true,
            create: true,
            update: true,
            delete: false,
        }">
        <template #row="{ item }">
            <div>
                <div class="container">
                    <div class="row align-items-center">
                        <a-list-item-meta>
                            <h5 slot="title">
                                {{ item.meta.city || item.meta.state }}
                            </h5>
                            <div slot="description" class="text-secondary">
                                <div>
                                    <a-icon type="environment" />
                                    {{ item.meta.country }} / {{ item.meta.state }} / {{ item.meta.city }}
                                </div>
                                <div>
                                    {{ item.operators.map(operator => $t(`enum.operator.${operator}`)).join(' | ') }}
                                </div>
                            </div>
                        </a-list-item-meta>
                        <a-tag class="text-uppercase">
                            {{ $t('region') }} {{ item.data.region }}
                        </a-tag>
                        <a-tag class="text-uppercase">
                            {{ $t('rate') }} {{ item.data.rate }}
                        </a-tag>

                    </div>
                </div>
            </div>
        </template>
        <template #actions="{ item }">
            <!-- Edit -->
            <router-link :to="`zones/${item.id}/update`">
                <a-button shape="circle" icon="setting" />
            </router-link>
        </template>
    </j-abm>
</template>

<script>
import lms from '@/api/lms'
import acl from '@/auth/acl'
import { activation } from '@/utils/styles'
import JAbm from '@/views/shared/abm/search'
export default {
  components: {
    JAbm,
  },
  name: 'ZoneList',
  data: function () {
    return {
      acl,
      activation,
      pagination: {
        page: 1,
        size: 30,
      },
    }
  },
  computed: {
    suppliers() {
      return {
        search: query => lms.zone.search(query),
        fetchAll: page => lms.zone.fetchAll(page),
      }
    },
  },
  methods: {
  },
}
</script>
